import { render, staticRenderFns } from "./CustomerPortalLink.vue?vue&type=template&id=b669735c&"
import script from "./CustomerPortalLink.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports